<template>
  <div class="panel-body">

    <div class="banner-option border-bottom">
      <app-option-editor :data-title="$t('message.campaigns.message.button1')"
                         :data-interaction="interactionStored"
                         @change-auth="(evt) => $emit('update-option', {option: interactionStored.opcoes[0], data: {paginaPosAutenticacao: evt}})">
      </app-option-editor>
    </div>

  </div>
</template>

<script>
    import AppOptionEditor from './OptionEditor'
    import panelBody from '../mixins/panel-body'

    export default {
        components: {
            AppOptionEditor,
        },

        computed: {
            maxLength() {
                return this.interaction.opcoes.length === 1 ? 22 : 12
            },
        },

        methods: {

        },

        mixins: [panelBody]
    }
</script>

<style lang="scss" scoped>
@import "../mixins/panel-body";

.button-amount {
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  font-size: 14px;
  font-weight: bold;

  .checkbox-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .text {
      margin: 4px 0 0 -6px;
    }
  }
}
</style>
